import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { GenericErrorOps } from './interfaces/generic-error-ops.interface';
import { animate, style, transition, trigger } from '@angular/animations';
import { IonIcon, IonText, IonSpinner } from "@ionic/angular/standalone";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-generic-error",
    templateUrl: "./generic-error.component.html",
    styleUrls: ["./generic-error.component.scss"],
    animations: [
        trigger("myInsertRemoveTrigger", [
            transition(":enter", [
                style({ opacity: 0 }),
                animate("500ms ease-in-out", style({ opacity: 1 })),
            ]),
        ]),
    ],
    encapsulation: ViewEncapsulation.None,
    imports: [IonSpinner, IonText, IonIcon, CommonModule],
    standalone: true
})
export class GenericErrorComponent {
  
  @Input() ops: GenericErrorOps;
  @Input() retryAttempt: boolean;
  @Input() enableButtonRetry?: boolean = true;
  @Input() enableWhatsapp: boolean = true;
  @Output() retryEvent = new EventEmitter(); 
  @Output() goToEvent = new EventEmitter(); 


  get isErrorContainer():string{
    return this.isErrorBank ? 'container-root' : 'container-root-bank'
  }

  get isErrorTitle():string{
    return this.isErrorBank ? 'title' : 'titleBank'
  }

  get isErrorBank():boolean{
    return this.ops.subtitleRetry !== "" && this.ops.subtitleRetry !== undefined
  }

}
